import * as OnlineShopsApiService from '../services/api/requests/OnlineShops'
import * as MallApiService from '../services/api/requests/Mall'
// import ProfileApiServices from '../services/api/requests/Profile'
import { sortDataAlphabetically } from '../services/sortData'

export const doGetAllMalls = async setMalls => {
  MallApiService.getAllMalls()
    .then(response => {
      setMalls({
        malls: response.data,
        mallList: response.data.map(mall => ({
          name: mall.name,
          value: mall.slugName,
        })),
      })
    })
    .catch(() => {})
}

export const doGetAllBrands = async ({ accessToken }, setGetBrandsResults) => {
  // REMOVED - getAllBrands function no longer exists
  // OnlineShopsApiService.getAllBrands(accessToken || undefined).then(
  //   response => {
  //     const { data } = response
  //     const stores = data.sort(sortDataAlphabetically)
  //     setGetBrandsResults({
  //       stores,
  //       storeList: stores,
  //     })
  //   },
  // )
  setGetBrandsResults({
    stores: [],
    storeList: [],
  })
}

export const doGetShopCategories = async setCategories => {
  // REMOVED - getShopCategories function no longer exists
  // OnlineShopsApiService.getShopCategories().then(response => {
  //   const { data } = response
  //   const categoriesShop = data.map(category => {
  //     return { value: category.id, ...category }
  //   })
  //   setCategories({
  //     categories: [{ value: 'default', name: 'All' }, ...categoriesShop],
  //   })
  // })
  setCategories({
    categories: [{ value: 'default', name: 'All' }],
  })
}

export const doChangeCategories = ({
  accessToken,
  selectedCategory,
  setQueryResults,
}) => e => {
  const { value: categoryId } = e.target || {}
  if (categoryId !== selectedCategory) {
    // REMOVED - getAllBrands and getBrandByCategory functions no longer exist
    // if (categoryId === 'default') {
    //   OnlineShopsApiService.getAllBrands(accessToken || undefined).then(
    //     response => {
    //       const { data } = response
    //       setQueryResults({
    //         searchQuery: '',
    //         stores: data.sort(sortDataAlphabetically),
    //         selectedCategoryId: 'default',
    //       })
    //     },
    //   )
    // } else
    //   OnlineShopsApiService.getBrandByCategory(
    //     categoryId,
    //     accessToken || undefined,
    //   ).then(response => {
    //     const { data } = response
    //     setQueryResults({
    //       searchQuery: '',
    //       stores: data.sort(sortDataAlphabetically),
    //       selectedCategoryId: categoryId,
    //     })
    //   })
    setQueryResults({
      searchQuery: '',
      stores: [],
      selectedCategoryId: categoryId,
    })
  } else
    setQueryResults({
      searchQuery: '',
    })
}

// doGetPromoCode = async ({ accessToken, advanceAccount, setAccountStatus }) => {
//   if (accessToken && !advanceAccount)
//     await ProfileApiServices.getAccountStatus(accessToken)
//       .then(response => {
//         const { data } = response
//         setAccountStatus(data)
//         let accountType = accountTypeValue.guest
//         if (data.advanced) accountType = accountTypeValue.advanced
//         else accountType = accountTypeValue.basic
//         try {
//           OnlineShopsApiService.getPromoCode(accountType).then(response => {
//             const { data } = response

//             this.setState({
//               promoCode: data.code,
//             })
//           })
//         } catch {
//           this.setState({
//             promoCode: '',
//           })
//         }
//       })
//       .catch(() => {})
//   else if (accessToken && advanceAccount) {
//     let accountType = accountTypeValue.guest
//     if (advanceAccount.advanced) accountType = accountTypeValue.advanced
//     else accountType = accountTypeValue.basic
//     await OnlineShopsApiService.getPromoCode(accountType).then(response => {
//       const { data } = response
//       this.setState({
//         promoCode: data.code,
//       })
//     })
//   }
// }
